module.exports = __webpack_public_path__ + "images/MENUf5b4ed2143987c7a44caac6e347745b4.svg";